import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button } from 'components/common';
import { merge } from 'lib/javascript';
import { FormManager, Form, connectInput } from 'lib/form';
import validator from 'lib/validator';
import CouponCodeInput from '../CouponCodeInput';

const defaultValues = {
  coupon_code: '',
};

const validationSchema = validator.object({
  coupon_code: validator.string(),
});

const CouponCodeField = connectInput(CouponCodeInput, {
  onChangeArgType: 'raw-value',
});

const ApplyCouponCodeForm = ({
  initialValues,
  initialErrors,
  onSubmit,
}) => {
  const [error, setError] = useState(null);

  const handleOnSubmit = async ({ coupon_code }, actions) => {
    try {
      await onSubmit({ coupon_code });
      setError(null);
      actions.setStatus({ error: null });
      actions.setErrors(null);
      return;
    } catch (err) {
      setError(err.errors.message);
      actions.setErrors({ coupon_code: true });
      return;
    }
  };

  const getInitialValues = () =>
    merge({}, defaultValues, initialValues);

  return (
    <FormManager
      enableReinitialize
      initialValues={getInitialValues()}
      initialTouched={{ coupon_code: true }}
      initialErrors={initialErrors}
      validationSchema={validationSchema}
      onSubmit={handleOnSubmit}
    >
      {({ isSubmitting, values }) => (
        <Form>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
            }}
          >
            <div style={{ flex: 1 }}>
              <CouponCodeField
                name="coupon_code"
                placeholder="Enter Coupon Code"
                formGroupProps={{ className: 'tw-mb-0' }}
                helperProps={{
                  ...(error && { className: 'tw-hidden' }),
                }}
              />
            </div>
            <div>
              <Button
                type="submit"
                style={{ minWidth: 'unset' }}
                loading={isSubmitting}
                disabled={!(values?.coupon_code?.length > 0)}
              >
                Apply
              </Button>
            </div>
          </div>
          {error && (
            <p
              style={{
                color: 'red',
                marginBottom: 0,
                marginTop: '0.5rem',
                textAlign: 'left',
                lineHeight: '1.5',
              }}
            >
              {error}
            </p>
          )}
        </Form>
      )}
    </FormManager>
  );
};

ApplyCouponCodeForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default ApplyCouponCodeForm;
